import request from '@/utils/request'

export function fetchNlLocalePackStatus (locale) {
  return request({
    url: `/coffee/leo/nl/locale-packs/${encodeURIComponent(locale)}/status`,
    method: 'get'
  })
}

export function fetchNlLocalePackList () {
  return request({
    url: '/coffee/leo/nl/locale-packs',
    method: 'get'
  })
}

export function provisionNlLocalePack (locale, body, idempotencyKey) {
  return request({
    url: `/coffee/leo/nl/locale-packs/${encodeURIComponent(locale)}/provision`,
    method: 'post',
    data: body || { dryRun: false },
    headers: idempotencyKey ? { 'X-Idempotency-Key': idempotencyKey } : {}
  })
}

export function fetchNlLocalePackRun (runUid) {
  return request({
    url: `/coffee/leo/nl/locale-packs/runs/${encodeURIComponent(runUid)}`,
    method: 'get',
    timeout: 60000
  })
}

export function fetchNlLocalePackBudget () {
  return request({
    url: '/coffee/leo/nl/locale-packs/budget',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/leoNlLocalePack.js